<template>

    <div>
        <h3>Urenregistratie van gebruiker {{ user }}</h3>

        <div class="row">
            <div class="col-sm-3 col-md-3">
                <div class="form-horizontal">
                    <div class="form-group">
                        <label for="weeksInput" class="col-sm-4 control-label">Aantal weken</label>
                        <div class="col-sm-8">
                            <input type="number" class="form-control" id="weeksInput" v-model="weeks" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="weeknrInput" class="col-sm-4 control-label">Vanaf week</label>
                        <div class="col-sm-8">
                            <input type="number" class="form-control" id="weeknrInput" v-model="weeknr" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="yearInput" class="col-sm-4 control-label">Jaar</label>
                        <div class="col-sm-8">
                            <input type="number" class="form-control" id="yearInput" v-model="year" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="yearInput" class="col-sm-4 control-label">Kostcode</label>
                        <div class="col-sm-8">
                            <select v-model="costcode" class="form-control">
                                <option value="">-- Alle kostcodes --</option>
                                <option v-for="costcode in costcodes" :value="costcode.id">{{ costcode.label }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group text-right">
                        <button class="btn btn-primary btn-sm" @click="getTimeregistration">Gegevens ophalen</button>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="pull-right">
                <div class="btn-group btn-group-sm">
                    <json-excel
                        :data="getExcelData"
                        :fields="getExcelFields"
                        name="export.xls"
                        class="btn btn-default"
                        v-tooltip="'Exporteer naar Excel'"
                    >
                        <i class="mdi mdi-file-excel-box"></i>
                    </json-excel>
                    <button class="btn btn-default"
                        @click="exportToPdf()"
                        v-tooltip="'Exporteer naar PDF'"
                    >
                        <i class="mdi mdi-file-pdf-box"></i>
                    </button>
                </div>
            </div>
            <h4>Resultaten</h4>
        </div>
        <table class="table table-striped table-hover" id="tr-results">
            <thead>
                <tr>
                    <th>Datum</th>
                    <th>Uren</th>
                    <th>Kostcode</th>
                    <th>Project / taak</th>
                    <th>Toelichting</th>
                    <th v-if="isAdmin"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="timeregistration.length === 0">
                    <td colspan="5">Er zijn geen resultaten gevonden</td>
                </tr>
                <tr v-for="timereg in timeregistration">
                    <td v-text="timereg.date"></td>
                    <td>
                        <input v-if="editingEntry.id === timereg.id" type="number" v-model="editingEntry.hours"/>
                        <span v-else>
                            {{ timereg.hours }}
                        </span>
                    </td>
                    <td>
                        <select v-if="editingEntry.id === timereg.id" v-model="editingEntry.costCode">
                            <option v-for="costCode in costcodes" :value="costCode.id">
                                {{ costCode.label }}
                            </option>
                        </select>
                        <span v-else>
                            {{ timereg.costcode }}
                        </span>
                    </td>
                    <td>
                        <select v-if="editingEntry.id === timereg.id" v-model="editingEntry.project">
                            <option v-for="project in projects" :value="project.uuid">
                                {{ project.project_name }}
                            </option>
                        </select>
                        <span v-else>
                            {{ getProjectTaskName(timereg) }}
                        </span>
                    </td>
                    <td v-text="timereg.description"></td>
                    <td v-if="isAdmin">
                        <i v-if="editingEntry.id === timereg.id" @click="saveEntry" class="mdi mdi-file"/>
                        <i v-else @click="editEntry(timereg)" class="mdi mdi-pencil"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

</template>

<script>

import axios from 'axios';
import moment from 'moment';
import JsonExcel from 'vue-json-excel';
import jsPDF from "jspdf";
import {mapGetters} from "vuex";

export default {

    components: {
        JsonExcel,
    },

    computed: {

        getExcelData() {
            let data = [];
            this.timeregistration.forEach(timereg => {
                data.push({
                    date:timereg.date,
                    hours:timereg.hours,
                    costcode:timereg.costcode,
                    projecttask:this.getProjectTaskName(timereg),
                    description:timereg.description,
                });
            });
            return data;
        },

        getExcelFields() {
            return {
                'Datum':'date',
                'Uren': 'hours',
                'Kostcode': 'costcode',
                'Project/Taak': 'projecttask',
                'Toelichting':'description',
            };
        },

        getParams() {
            let object = {
                weeknr:this.weeknr,
                weeks:this.weeks,
                year:this.year,
            };

            if (this.costcode !== '') {
                object.costcode = this.costcode;
            }

            return object;
        },

        ...mapGetters([
            'isAdmin',
        ]),
    },

    data() {
        return {
            costcode:'',
            costcodes:[],
            projects: [],
            weeknr:34,
            weeks:6,
            year:2019,
            timeregistration:[],
            user:'',
            editingEntry: {
                id: null,
                hours: null,
                costCode: null,
                project: null,
            }
        }
    },

    methods: {

        exportToPdf() {
            let doc = new jsPDF({orientation:'landscape'});
            doc.autoTable({html:'#tr-results'});
            doc.save('export.pdf');
        },

        getCostcodes(){
            axios.get(this.costcodesUri)
                .then(resp => {
                    this.costcodes = resp.data.data;
                });
        },

        getProjects() {
            axios.get(this.route('api.v1.projects.index'))
                .then((response) => {
                    this.projects = response.data.data;
                });
        },

        getProjectTaskName(timereg) {
            if (timereg.task === '' && timereg.project === '') {
                return '000-Bureau';
            }
            return timereg.project + ' / ' + timereg.task;
        },

        getTimeregistration() {
            axios.get(this.timeregistrationUri, {params:this.getParams})
            .then(resp => {
                this.user = resp.data.data.user;
                this.timeregistration = resp.data.data.timeregistration;
            })
        },

        setPeriod() {
            let date = moment();
            let year = parseInt(date.format('YYYY'));

            let weeknr = parseInt(date.format('w')) - 6;
            if (weeknr < 1) {
                weeknr = 52 + weeknr;
                year--;
            }
            else if (weeknr > 52) {
                weeknr = weeknr - 52;
                year--;
            }

            this.year = year;
            this.weeknr = weeknr;
        },

        editEntry(entry) {
            this.editingEntry.id = entry.id;
            this.editingEntry.hours = entry.hours;
            this.editingEntry.costCode = entry.costcode.split('-')[0];
            this.editingEntry.project = entry.project_uuid;
        },

        saveEntry() {
            axios.put(
                this.route('api.v1.timeregistration.update-single', this.editingEntry.id),
                {
                    hours: this.editingEntry.hours,
                    costCode: this.editingEntry.costCode,
                    project: this.editingEntry.project,
                })
                .then((response) => {
                    if (response.data.success) {
                        this.editingEntry.id = null;
                        this.getTimeregistration();
                    }
                });
        }
    },

    mounted() {
        this.setPeriod();
        this.getCostcodes();
        this.getProjects();
        this.getTimeregistration();
    },

    name:"HrTimeregistrationUser",

    props: {

        costcodesUri: {
            required:true,
            type:String,
        },

        timeregistrationUri: {
            required:true,
            type:String,
        },

    }

}

</script>
